<template>
  <div class="h-100" style="position: relative;" :style="{ overflow: tabList.length > 0 ? 'unset' : 'hidden' }">
    <!-- <div
      style="margin: 10px;display: flex;justify-content: space-between;align-items: center;margin-right: 30px;"
    >
      <div style="font-size: 20px">{{ title }}</div> -->
      <div style="position: absolute; top: 10px; right: 10px; z-index: 10">
        <a-space>
          <a-button key="submit" v-if="Authorities.find(a => a.code === 'device:manage:device:update' || a.code === 'agent:device:manage:device:update') && deviceTabKey === 'details'" type="primary" @click="save">{{ $t('buttons.save') }}</a-button>
          <a-button key="submit" @click="goBack">{{ $t('buttons.goBack') }}</a-button>
          <a-button type="primary" v-if="Authorities.find(a => a.code === 'device:manage:device:history:query') && deviceForm.code" @click="$router.push({
              name: 'history',
              params: {
                machineId: deviceForm.code,
                machineType: deviceForm.model,
                protocolCode: deviceForm.protocolCode,
                id: deviceForm.id,
                intervalTime: deviceForm.intervalTime,
                name: deviceForm.name
                // port_no: list[0].port_no
              }
            })">{{ $t('device.history') }}</a-button>
        </a-space>
      </div>
    <!-- </div> -->
    <!-- <a-divider /> -->
    <div style="position: relative;" class="deviceDetail" :style="{ height: tabList.length > 0 ? isAgent ? '46%' : '58%' : '100%' }">
      <a-card style="height: 100%" :tab-list="deviceTabList" :active-tab-key="deviceTabKey" @tabChange="key => onDeviceTabChange(key)">
        <a-form-model
          style="width: 100%; display: flex; justify-content: space-between; padding: 20px 40px 0 20px; padding-left: 0"
          v-if="deviceTabKey === 'details'"
          v-bind="{labelCol: { span: 8 },wrapperCol: { span: 16 }}"
          :rules="rules"
          :model="deviceForm"
          ref="ruleForm"
        >
          <div style="width: 24%">
            <a-form-model-item :label="$t('common.deviceType')" prop="type">
              <a-select :disabled="title === '编辑设备'" v-model="deviceForm.type">
                <a-select-option
                  v-for="item in deviceTypeList"
                  :key="item.id"
                  :value="item.value"
                  @click.native="handleTypeChange(item.value)"
                >{{ item.text }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <!-- <a-form-model-item label="设备状态" prop="status">
              <a-select v-model="deviceForm.status">
                <a-select-option v-for="item in deviceStatusList" :key="item.id" :value="item.value">{{ item.text }}</a-select-option>
              </a-select>
            </a-form-model-item>-->
            <a-form-model-item :label="$t('common.deviceCode')" prop="code">
              <a-input :disabled="title === '编辑设备'" v-model="deviceForm.code" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.deviceName')" prop="name">
              <a-input v-model="deviceForm.name" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.deviceAddress')" prop="deviceAddress">
              <a-input v-model="deviceForm.deviceAddress" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.model')" prop="model">
              <a-input v-model="deviceForm.model" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('device.businessType')" prop="businessType" v-if="!isAgent">
              <a-select v-model="deviceForm.businessType">
                <a-select-option v-for="t in businessTypes" :key="t.value"> {{ t.text }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <div style="width: 24%">
            <a-form-model-item :label="$t('common.customer')"  prop="customerId">
              <a-select
                show-search
                v-model="deviceForm.customerId"
                :placeholder="$t('placeholder.searchCustomer')"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                @search="handleSearchCustomer"
                @popupScroll="handlePopupScroll"
                @blur="handleBlur"
              >
                <a-select-option v-for="d in customerResultList" :key="d.id">{{ d.company }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.protocolCode')" prop="protocolCode" style="position: relative;">
              <a-select
                show-search
                v-model="deviceForm.protocolCode"
                :placeholder="$t('placeholder.searchProtocolCode')"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                @search="handleSearchProtocol"
                @popupScroll="handleProtocolPopupScroll"
                @blur="handleBlur"
                @change="handleChange"
                option-label-prop="label"
              >
                <a-select-option
                  :title="d.code + ' - ' + d.name"
                  v-for="d in protocolList"
                  :key="d.code"
                  :value="d.code"
                  :label="d.code"
                >{{ d.code }} - {{ d.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.driverType')" prop="driverType">
              <a-select style="width: 100%;" disabled v-model="deviceForm.driverType">
                <a-select-option v-for="drive in driveTypeList" :key="drive.value">{{ drive.text }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.intervalTime')" prop="intervalTime">
              <a-select
                style="width: 100%;"
                v-model="deviceForm.intervalTime"
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              >
                <a-select-option value="10">10</a-select-option>
                <a-select-option value="30">30</a-select-option>
                <a-select-option value="60">60</a-select-option>
                <a-select-option value="180">180</a-select-option>
                <a-select-option value="300">300</a-select-option>
                <a-select-option value="600">600</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.dtuCode')" prop="dtuCode">
              <a-input v-model="deviceForm.dtuCode" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.startTime')" v-if="!isAgent">
              <a-date-picker placeholder="" style="width: 100%" v-model="deviceForm.startTime" />
            </a-form-model-item>
          </div>
          <div style="width: 24%">
            <a-form-model-item :label="$t('common.brand')">
              <a-input v-model="deviceForm.brand" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.installAddress')">
              <a-input v-model="deviceForm.installAddress" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.measurement')" prop="measurement">
              <a-input v-model="deviceForm.measurement" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.initialValue')" prop="initialValue">
              <a-input v-model="deviceForm.initialValue" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.remark')">
              <a-input v-model="deviceForm.remark" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.endTime')" v-if="!isAgent">
              <a-date-picker placeholder="" style="width: 100%" v-model="deviceForm.endTime" />
            </a-form-model-item>
          </div>
          <div style="width: 24%" class="nLabel">
            <a-form-model-item :label="$t('common.power')">
              <a-input v-model="deviceForm.power" type="text"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.pressure')">
              <a-input v-model="deviceForm.pressure" type="text"></a-input>
            </a-form-model-item>
            <!-- <a-form-model-item :label="$t('common.warrantyPeriod')" v-if="!isAgent">
              <a-input v-model="deviceForm.warrantyPeriod" type="text"></a-input>
            </a-form-model-item> -->
            <a-form-model-item :label="$t('device.enable')">
              <a-switch :checked-children="$t('device.no')" :un-checked-children="$t('device.yes')" v-model="deviceForm.enabled" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.isStationDevice')" v-if="!isAgent">
              <a-switch
                :checked-children="$t('common.yes')"
                :un-checked-children="$t('common.no')"
                v-model="deviceForm.isStationDevice"
              />
            </a-form-model-item>
            <a-form-model-item :label="$t('device.countDown')" v-if="!isAgent">
              <a-input v-model="countDown" disabled />
            </a-form-model-item>
            <a-form-model-item :label="$t('device.warningTag')">
              <a-select v-model="deviceForm.tag" dropdownClassName="warningTagOption">
                <a-select-option v-for="w in warningTags" :key="w.value">
                  {{ w.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
        </a-form-model>
        <a-form-model v-if="deviceTabKey === 'details'" style="width: 100%; display: flex; justify-content: space-between; padding-left: 62px; padding-top: 0" v-bind="{labelCol: { span: 1 }, wrapperCol: { span: 22 }}">
          <a-form-model-item :label="$t('device.bindingDevice')" style="width: 100%" v-if="!isAgent">
            <div
              tabindex="-1"
              class="ant-select ant-select-enabled"
              data-v-a1ccd506
              style="width: 102%;"
            >
              <div
                @click="showDeviceTableModal"
                role="combobox"
                aria-autocomplete="list"
                aria-haspopup="true"
                aria-controls="50e5fa56-0e69-45c7-d94a-6b44d9a8df95"
                class="ant-select-selection ant-select-selection--multiple"
              >
                <div class="ant-select-selection__rendered">
                  <ul>
                    <li
                      v-for="(s, i) in selectedDeviceList"
                      :key="s.id"
                      @click.stop
                      unselectable="on"
                      role="presentation"
                      title="a1"
                      class="ant-select-selection__choice"
                      style="user-select: none;"
                    >
                      <div class="ant-select-selection__choice__content">{{ s.name }}</div>
                      <span class="ant-select-selection__choice__remove">
                        <i
                          @click="handleRemoveSelectedDevice(i)"
                          aria-label="图标: close"
                          class="anticon anticon-close ant-select-remove-icon"
                        >
                          <svg
                            viewBox="64 64 896 896"
                            data-icon="close"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                            class
                          >
                            <path
                              d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                            />
                          </svg>
                        </i>
                      </span>
                    </li>
                    <li class="ant-select-search ant-select-search--inline">
                      <div class="ant-select-search__field__wrap">
                        <input autocomplete="off" value class="ant-select-search__field" />
                        <span class="ant-select-search__field__mirror">&nbsp;</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </a-form-model-item>
          <a-modal
            :title="$t('device.deviceSelect')"
            v-model="isDeviceTableVisible"
            :width="1250"
            @ok="handleConfirm"
          >
            <a-table
              row-key="id"
              :loading="deviceTableLoading"
              :columns="columns"
              :data-source="deviceList"
              :pagination="pagination"
              :row-selection="rowSelection"
              @change="handlePageChange"
            >
              <template v-slot:code="text">
                <text-highlight :queries="[highLightInfo.code]">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:name="text">
                <text-highlight :queries="[highLightInfo.name]">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:model="text">
                <text-highlight :queries="[highLightInfo.model]">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:company="text">
                <text-highlight :queries="[highLightInfo['customer.company']]">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:type="text">
                {{ deviceTypeMap[text] }}
              </template>
              <template v-slot:protocolCode="text">
                <text-highlight :queries="[highLightInfo.protocolCode]">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:dtuCode="text">
                <text-highlight :queries="[highLightInfo.dtuCode]">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:driverType="text">
                <text-highlight :queries="[highLightInfo.driverType]">
                  {{ text }}
                </text-highlight>
              </template>
            </a-table>
          </a-modal>
        </a-form-model>
        <div v-else-if="deviceTabKey === 'map'" class="w-100" style="position: relative; height: calc(100% - 55px)">
          <div id="map" ref="mapChart">  
          </div>
          <div class="icon" @click="refreshPosition">
            <a-icon v-if="vincinityLoading" type="loading" style="font-size: 25px" />
            <a-icon v-else type="reload" style="font-size: 25px" />
          </div>
        </div>
        <div v-else-if="deviceTabKey === 'monitor'" class="w-100 h-100" style="position: relative; height: calc(100% - 55px)">
          <Monitor v-if="deviceTabKey === 'monitor'" :device="deviceForm" ref="monitor" />
        </div>
        <div v-else-if="deviceTabKey === 'warning'" class="w-100 h-100" style="position: relative; height: calc(100% - 55px)">
          <a-menu mode="horizontal" v-model="currentWarningMode">
            <a-menu-item key="warningRemind">{{ $t("warning.device") }}</a-menu-item>
            <a-menu-item key="warningHistory">{{ $t("warningHistory.title") }}</a-menu-item>
          </a-menu>
          <template v-if="currentWarningMode[0] === 'warningRemind'">
            <WarningRemind style="margin-top: 15px" :device="deviceForm" :showDetailMethod="null" :isTitleShow="false" />
          </template>
          <template v-if="currentWarningMode[0] === 'warningHistory'">
            <WarningHistory :device="deviceForm" />
          </template>
        </div>
      </a-card>
    </div>
    <div class="orders" v-if="tabList.length > 0 && this.title === '编辑设备'">
      <a-card v-if="tabList.length" :tab-list="tabList" :active-tab-key="tabKey" @tabChange="key => onTabChange(key)">
        <template v-if="tabKey === 'record'">
          <a-form-model layout="inline" style="margin-bottom: 10px">
            <a-form-model-item :label="$t('common.operationUser')">
              <a-input v-model="params.name" />
            </a-form-model-item>
            <a-form-model-item v-show="params.module === 'device-manage'" :label="$t('common.request')">
              <a-select v-model="params.request" style="width: 130px">
                <a-select-option value>{{ $t('common.request') }}</a-select-option>
                <a-select-option value="POST">{{ $t('buttons.add') }}</a-select-option>
                <a-select-option value="PUT">{{ $t('common.update') }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item v-show="params.module === 'device-connect'" :label="$t('common.request')">
              <a-select v-model="params.path" style="width: 130px">
                <a-select-option value>{{ $t('common.request') }}</a-select-option>
                <a-select-option value="/device/write/value">{{ $t('device.writeValue') }}</a-select-option>
                <a-select-option value="/device/switch">{{ $t('device.switchDevice') }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('device.moduleChanged')">
              <a-select v-model="params.module" style="width: 120px" @change="handleModuleChange">
                <a-select-option value="device-manage">{{ $t('device.deviceInfo') }}</a-select-option>
                <a-select-option value="device-connect">{{ $t('device.deviceConnect') }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('common.startTime')">
              <a-date-picker @change="changeStartTime" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.endTime')">
              <a-date-picker @change="changeEndTime" />
            </a-form-model-item>
            <a-button type="primary" style="float: right" @click="getS">{{ $t('buttons.search') }}</a-button>
          </a-form-model>
          <el-table
            :key="tabKey"
            :data="systemLogList"
            style="width: 100%"
            :header-cell-style="{ backgroundColor: '#fafafa' }"
            v-loading="isSystemLogLoading"
            @expand-change="handleExpand"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div style="padding: 0 50px">
                  <!-- <a-spin v-show="!props.row.description"></a-spin> -->
                  <div v-show="props.row.description" class="system_log_description">
                    <h3 style="margin-bottom: 15px">{{ $t('common.details') }}</h3>
                    <div class="description" v-if="currentModule === 'device-manage'">
                      <a-row>
                        <a-col :span="5">
                          <p v-if="Array.isArray(props.row.description.type)">
                            {{ $t('common.deviceType') }}: 
                            <span style="color: red">{{ deviceTypeMap[props.row.description.type[0]] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ deviceTypeMap[props.row.description.type[1]] }}</span>
                          </p>
                          <p v-else>{{ $t('common.deviceType') }}: {{ deviceTypeMap[props.row.description.type] }}</p>
                          <p v-if="Array.isArray(props.row.description.code)">
                            {{ $t('common.deviceCode') }}: 
                            <span style="color: red">{{ props.row.description.code[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.code[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.deviceCode') }}: {{ props.row.description.code }}</p>
                          <p v-if="Array.isArray(props.row.description.name)">
                            {{ $t('common.deviceName') }}: 
                            <span style="color: red">{{ props.row.description.name[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.name[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.deviceName') }}: {{ props.row.description.name }}</p>
                          <p v-if="Array.isArray(props.row.description.deviceAddress)">
                            {{ $t('common.deviceAddress') }}: 
                            <span style="color: red">{{ props.row.description.deviceAddress[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.deviceAddress[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.deviceAddress') }}: {{ props.row.description.deviceAddress }}</p>
                          <p v-if="Array.isArray(props.row.description.model)">
                            {{ $t('common.model') }}: 
                            <span style="color: red">{{ props.row.description.model[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.model[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.model') }}: {{ props.row.description.model }}</p>
                          <p v-if="Array.isArray(props.row.description.businessType)">
                            {{ $t('device.businessType') }}: 
                            <span style="color: red">{{ businessTypeMap[props.row.description.businessType[0]] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ businessTypeMap[props.row.description.businessType[1]] }}</span>
                          </p>
                          <p v-else>{{ $t('device.businessType') }}: {{ businessTypeMap[props.row.description.businessType] }}</p>
                        </a-col>
                        <a-col :span="7">
                          <p v-if="Array.isArray(props.row.description.company)">
                            {{ $t('common.customer') }}: 
                            <span style="color: red">{{ props.row.description.company[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.company[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.customer') }}: {{ props.row.description.company }}</p>
                          <p v-if="Array.isArray(props.row.description.protocolCode)">
                            {{ $t('common.protocolCode') }}: 
                            <span style="color: red">{{ props.row.description.protocolCode[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.protocolCode[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.protocolCode') }}: {{ props.row.description.protocolCode }}</p>
                          <p v-if="Array.isArray(props.row.description.driverType)">
                            {{ $t('common.driverType') }}: 
                            <span style="color: red">{{ props.row.description.driverType[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.driverType[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.driverType') }}: {{ props.row.description.driverType }}</p>
                          <p v-if="Array.isArray(props.row.description.intervalTime)">
                            {{ $t('common.intervalTime') }}: 
                            <span style="color: red">{{ props.row.description.intervalTime[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.intervalTime[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.intervalTime') }}: {{ props.row.description.intervalTime }}</p>
                          <p v-if="Array.isArray(props.row.description.dtuCode)">
                            {{ $t('common.dtuCode') }}: 
                            <span style="color: red">{{ props.row.description.dtuCode[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.dtuCode[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.dtuCode') }}: {{ props.row.description.dtuCode }}</p>
                          <p v-if="Array.isArray(props.row.description.tag)">
                            {{ $t('device.warningTag') }}: 
                            <span style="color: red">{{ props.row.description.tag[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.tag[1] }}</span>
                          </p>
                          <p v-else>{{ $t('device.warningTag') }}: {{ props.row.description.tag }}</p>
                        </a-col>
                        <a-col :span="8">
                          <p v-if="Array.isArray(props.row.description.brand)">
                            {{ $t('common.brand') }}: 
                            <span style="color: red">{{ props.row.description.brand[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.brand[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.brand') }}: {{ props.row.description.brand }}</p>
                          <p v-if="Array.isArray(props.row.description.installAddress)">
                            {{ $t('common.installAddress') }}: 
                            <span style="color: red">{{ props.row.description.installAddress[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.installAddress[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.installAddress') }}: {{ props.row.description.installAddress }}</p>
                          <p v-if="Array.isArray(props.row.description.measurement)">
                            {{ $t('common.measurement') }}: 
                            <span style="color: red">{{ props.row.description.measurement[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.measurement[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.measurement') }}: {{ props.row.description.measurement }}</p>
                          <p v-if="Array.isArray(props.row.description.initialValue)">
                            {{ $t('common.initialValue') }}: 
                            <span style="color: red">{{ props.row.description.initialValue[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.initialValue[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.initialValue') }}: {{ props.row.description.initialValue }}</p>
                          <p v-if="Array.isArray(props.row.description.remark)">
                            {{ $t('common.remark') }}: 
                            <span style="color: red">{{ props.row.description.remark[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.remark[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.remark') }}: {{ props.row.description.remark }}</p>
                          <p v-if="Array.isArray(props.row.description.startTime)">
                            {{ $t('common.startTime') }}: 
                            <span style="color: red">{{ props.row.description.startTime[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.startTime[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.startTime') }}: {{ props.row.description.startTime }}</p>
                        </a-col>
                        <a-col :span="4">
                          <p v-if="Array.isArray(props.row.description.power)">
                            {{ $t('common.power') }}: 
                            <span style="color: red">{{ props.row.description.power[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.power[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.power') }}: {{ props.row.description.power }}</p>
                          <p v-if="Array.isArray(props.row.description.pressure)">
                            {{ $t('common.pressure') }}: 
                            <span style="color: red">{{ props.row.description.pressure[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.pressure[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.pressure') }}: {{ props.row.description.power }}</p>
                          <p v-if="Array.isArray(props.row.description.warrantyPeriod)">
                            {{ $t('common.warrantyPeriod') }}: 
                            <span style="color: red">{{ props.row.description.warrantyPeriod[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.warrantyPeriod[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.warrantyPeriod') }}: {{ props.row.description.warrantyPeriod }}</p>
                          <p v-if="Array.isArray(props.row.description.enabled)">
                            {{ $t('device.enable') }}: 
                            <span style="color: red">{{ props.row.description.enabled[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.enabled[1] }}</span>
                          </p>
                          <p v-else>{{ $t('device.enable') }}: {{ props.row.description.enabled }}</p>
                          <p v-if="Array.isArray(props.row.description.isStationDevice)">
                            {{ $t('common.isStationDevice') }}: 
                            <span style="color: red">{{ props.row.description.isStationDevice[0] ? $t('common.yes') : $t('common.no') }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.isStationDevice[1] ? $t('common.yes') : $t('common.no') }}</span>
                          </p>
                          <p v-else>{{ $t('common.isStationDevice') }}: {{ props.row.description.isStationDevice ? $t('common.yes') : $t('common.no') }}</p>
                          <p v-if="Array.isArray(props.row.description.endTime)">
                            {{ $t('common.endTime') }}: 
                            <span style="color: red">{{ props.row.description.endTime[0] }}</span>
                            <span>→</span>
                            <span style="color: green">{{ props.row.description.endTime[1] }}</span>
                          </p>
                          <p v-else>{{ $t('common.endTime') }}: {{ props.row.description.endTime }}</p>
                        </a-col>
                      </a-row>
                    </div>
                    <div class="description" v-if="currentModule === 'device-connect'">
                      <p>{{ $t('common.deviceCode') }}: {{ props.row.description.deviceCode }}</p>
                      <p>{{ $t('common.deviceCode') }}: {{ props.row.description.dtuCode }}</p>
                      <p>{{ $t('device.pointCode') }}: {{ props.row.description.pointCode }}</p>
                      <p>{{ $t('device.value') }}: {{ props.row.description.value }}</p>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作用户" prop="user.realName">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.operationUser') }}</div>
              </template>
            </el-table-column>
            <el-table-column label="用户号码" prop="user.username">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.mobile') }}</div>
              </template>
            </el-table-column>
            <el-table-column label="用户组织" prop="user.organizationName">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.organization') }}</div>
              </template>
            </el-table-column>
            <el-table-column label="修改方式" prop="request">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.request') }}</div>
              </template>
            </el-table-column>
            <el-table-column label="修改时间" prop="time">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.changeTime') }}</div>
              </template>
            </el-table-column>
          </el-table>
          <div style="height: 40px">
            <a-pagination
              style="float: right; margin: 16px 0"
              :current="systemLogPagination.current"
              :pageSize="systemLogPagination.pageSize"
              :total="systemLogPagination.total"
              @change="handleSystemPageChange"
            />
          </div>
        </template>
        <template v-if="tabKey === 'orders'">
          <!-- <a-table
            :columns="ordersColumns"
            :data-source="orders"
          >
          </a-table>-->
          <a-button v-if="Authorities.find(a => a.code === 'after:sale:order:query')" :loading="addLoading" type="primary" style="position: absolute; top: 12px; right: 20px;" @click="showOrderModal">{{ $t('orders.add') }}</a-button>
          <el-table
            style="margin-top: 10px; width: 100%"
            row-key="preemptOrderId"
            v-loading="tableLoading"
            :data="orders"
            :header-cell-style="{ backgroundColor: '#fafafa' }"
          >
            <el-table-column prop="orderNo" width="140">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('orders.code') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="0">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <a-input @keyup.enter="getOrdersList" v-model.trim="orderParams.orderNo" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="highLightInfo.orderNo">{{ scope.row.orderNo }}</text-highlight>
              </template>
            </el-table-column>
            <el-table-column prop="orderType" width="100">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('orders.type') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="1">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <a-select @change="getOrdersList" v-model="orderParams.orderType" style="width: 90%">
                  <a-select-option value>{{ $t('common.all') }}</a-select-option>
                  <a-select-option v-for="(v, k) in typeMap" :key="k">{{ v }}</a-select-option>
                </a-select>
              </template>
              <template slot-scope="scope">{{ typeMap[scope.row.orderType] }}</template>
            </el-table-column>
            <el-table-column prop="orderState" width="100">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('orders.state') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <a-select
                  @change="getOrdersList"
                  v-model.trim="orderParams.orderState"
                  style="width: 100%;"
                >
                  <a-select-option value>{{ $t('common.all') }}</a-select-option>
                  <a-select-option v-for="(v, k) in stateMap" :key="k">{{ v }}</a-select-option>
                </a-select>
              </template>
              <template slot-scope="scope">
                {{ stateMap[scope.row.orderState] }}
              </template>
            </el-table-column>
            <el-table-column width="90">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('orders.receiver') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <a-input @keyup.enter="getOrdersList" v-model="orderParams.receiver" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="highLightInfo.receiver">{{ scope.row.receiver }}</text-highlight>
              </template>
            </el-table-column>
            <el-table-column prop="cancelState" width="100">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('orders.cancelState') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <a-select @change="getOrdersList" v-model="orderParams.cancelState" style="width: 100%;">
                  <a-select-option value="0">{{ $t('orders.yes') }}</a-select-option>
                  <a-select-option value="1">{{ $t('orders.no') }}</a-select-option>
                </a-select>
              </template>
              <template slot-scope="scope">
                {{ scope.row.cancelState ? $t('orders.no') : $t('orders.yes') }}
              </template>
            </el-table-column>
            <el-table-column prop="company" width="300">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('common.customer') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <a-input @keyup.enter="getOrdersList" v-model.trim="orderParams.company" />
              </template>
              <template slot-scope="scope">
                  <text-highlight :queries="highLightInfo.company">{{ scope.row.company }}</text-highlight>
              </template>
            </el-table-column>
            <el-table-column prop="contactPerson" width="100">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('orders.contactPerson') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <a-input @keyup.enter="getOrdersList" v-model.trim="orderParams.contactPerson" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="highLightInfo.contactPerson">{{ scope.row.contactPerson }}</text-highlight>
              </template>
            </el-table-column>
            <el-table-column prop="deviceCode" width="150">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('common.deviceCode') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.deviceCode }}
              </template>
            </el-table-column>
            <el-table-column prop="deviceName">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('common.deviceName') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.deviceName }}
              </template>
            </el-table-column>
            <el-table-column prop="orderScore" width="100">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('orders.orderScore') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <!-- <a-input /> -->
              </template>
            </el-table-column>
            <el-table-column prop="finishTime" width="150">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('orders.finishTime') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <!-- <a-input /> -->
              </template>
            </el-table-column>
            <el-table-column prop="note">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('common.remark') }}
                  <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
                  </span>-->
                </div>
                <!-- <a-input /> -->
              </template>
            </el-table-column>
            <!-- <el-table-column prop="createdAt">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">创建时间<span class="icons unset" style="cursor: pointer;" data-index="0">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input />
        </template>
            </el-table-column>-->
            <el-table-column width="120">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.operation') }}</div>
              </template>
              <template slot-scope="scope">
                <a-button
                  v-if="Authorities.find(a => a.code === 'after:sale:order:update')"
                  style="padding-left: 0; margin-left: -3px"
                  type="link"
                  @click="gotoEdit(scope.row)"
                >{{ $t('buttons.edit') }}</a-button>
                <a-button
                  v-if="Authorities.find(a => a.code === 'after:sale:order:rush')"
                  :loading="scope.row.readyToRush"
                  style="padding-left: 0; margin-left: -3px"
                  type="link"
                  @click="showRushModal(scope.row)"
                >{{ $t('orders.rush') }}</a-button>
                <!-- <a-popconfirm
            title="确认要删除吗?"
            ok-text="确认"
            cancel-text="取消"
          >
            <a-button type="link" style="padding-left: 0">删除</a-button>
                </a-popconfirm>-->
              </template>
            </el-table-column>
          </el-table>
          <a-pagination
            style="float: right; margin-top: 20px; padding-bottom: 20px"
            :current="orderPagination.current"
            :total="orderPagination.total"
            :pageSize="orderPagination.pageSize"
            @change="handleOrderPageChange"
          />
        </template>
        <template v-if="tabKey==='service'">
          <a-button v-if="Authorities.find(a => a.code === 'after:sale:document:insert')" :loading="addLoading" type="primary" style="position: absolute; top: 12px; right: 20px;" @click="showServiceModal">{{ $t('saleDocument.add') }}</a-button>
          <el-table
            stripe
            style="width: 100%"
            v-loading="isSLoading"
            :data="serviceList"
            :header-cell-style="{ backgroundColor: '#fafafa' }"
          >
            <el-table-column prop="orderNum" label="订单编号" width="160">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('orders.code') }}
                </div>
                <a-input v-model.trim="SQueryParams.orderNum" allow-clear @keyup.enter="getData(true)" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="sHighLightInfo.orderNum">{{ scope.row.orderNum }}</text-highlight>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="equipmentCode" label="整机编号" width="160">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  整机编号
                </div>
                <a-input v-model.trim="SQueryParams.equipmentCode" allow-clear @keyup.enter="getData(true)" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="sHighLightInfo.equipmentCode">{{ scope.row.equipmentCode }}</text-highlight>
              </template>
            </el-table-column> -->
            <el-table-column prop="equipmentName" label="设备名称" width="200">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('common.deviceName') }}
                </div>
                <a-input v-model.trim="SQueryParams.equipmentName" allow-clear @keyup.enter="getData(true)" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="sHighLightInfo.equipmentName">{{ scope.row.equipmentName }}</text-highlight>
              </template>
            </el-table-column>
            <el-table-column prop="equipmentModel" label="规格型号" width="100">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('common.model') }}
                </div>
                <a-input v-model.trim="SQueryParams.equipmentModel" allow-clear @keyup.enter="getData(true)" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="sHighLightInfo.equipmentModel">{{ scope.row.equipmentModel }}</text-highlight>
              </template>
            </el-table-column>
            <el-table-column prop="serviceType" label="服务类型" width="100">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('saleDocument.serviceType') }}
                </div>
                <a-select
                  v-model="SQueryParams.serviceType"
                  style="width: 80px"
                  @change="getData(true)"
                >
                  <a-select-option value>{{ $t('common.all') }}</a-select-option>
                  <a-select-option v-for="(value, key) in typeMap" :key="key">{{ value }}</a-select-option>
                </a-select>
              </template>
              <template slot-scope="scope">
                {{ typeMap[scope.row.serviceType] }}
              </template>
            </el-table-column>
            <el-table-column prop="customer" label="客户名称" width="220">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('common.customerName') }}
                </div>
                <a-input v-model.trim="SQueryParams.customer" allow-clear @keyup.enter="getData(true)" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="sHighLightInfo.customer">{{ scope.row.customer }}</text-highlight>
              </template>
            </el-table-column>
            <el-table-column prop="updateman" label="修改人" width="130">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('saleDocument.updateman') }}
                </div>
                <a-input v-model.trim="SQueryParams.updateman" allow-clear @keyup.enter="getData(true)" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="sHighLightInfo.updateman">{{ scope.row.updateman }}</text-highlight>
              </template>
            </el-table-column>
            <el-table-column prop="serviceMan" label="服务员" width="130">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('common.serviceMen') }}
                </div>
                <a-input v-model.trim="SQueryParams.serviceman" allow-clear @keyup.enter="getData(true)" />
              </template>
              <template slot-scope="scope">
                <text-highlight :queries="sHighLightInfo.serviceman">{{ scope.row.serviceman }}</text-highlight>
              </template>
            </el-table-column>
            <el-table-column prop="equipmentCode" label="整机编号" width="160">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('device.code') }}
                </div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.equipmentCode }}
              </template>
            </el-table-column>
            <el-table-column prop="serviceTime" label="服务时间" width="200">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('saleDocument.serviceTime') }}
                </div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.serviceTime }}
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="200">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('saleDocument.updateTime') }}
                </div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.updateTime }}
              </template>
            </el-table-column>
            <el-table-column prop="createman" label="创建人" width="120">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('saleDocument.createman') }}
                </div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.createman }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('saleDocument.createTime') }}
                </div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.createTime }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
              <template #header>
                <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                  {{ $t('common.operation') }}
                </div>
              </template>
              <template slot-scope="scope">
                <a-button v-if="Authorities.find(a => a.code === 'after:sale:document:update')" style="padding-left: 0; margin-left: -3px" type="link" @click="onEdit(scope.row)">{{ $t('buttons.edit') }}</a-button>
                <a-popconfirm
                  :title="$t('messages.ctrd')"
                  :ok-text="$t('common.okText')"
                  :cancel-text="$t('common.cancelText')"
                  @confirm="removeService(scope.row)"
                >
                  <a-button v-if="Authorities.find(a => a.code === 'after:sale:document:delete')" :loading="scope.row.loading" type="link" style="padding-left: 0">{{ $t('buttons.delete') }}</a-button>
                </a-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <a-pagination
            style="float: right; margin-top: 20px; padding-bottom: 20px"
            :current="sPagination.current"
            :total="sPagination.total"
            :pageSize="sPagination.pageSize"
            @change="handleTableChange"
          />
        </template>
        <OrderModal :visible="orderVisible" :closeModal="closeModal" :orderNo="orderNo" :deviceId="deviceId" :customerId="customerId" :isDeviceDisabled="true" :isResetShow="false" />
        <ServiceModal
          :visible="SVisible"
          :title="sTitle"
          :typeMap="typeMap"
          :closeModal="closeSModal"
          :record="sRecord"
        />
        <a-modal :width="800" v-model="rushVisible" :title="$t('orders.rush')" @ok="rush" @cancel="clearRushForm" :confirmLoading="isRushing">
          <a-form-model
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
            style="display: flex; flex-wrap: wrap"
            class="group"
          >
            <div style="width: 50%; display: flex; justify-content: space-between;" class="inline">
              <a-form-model-item style="width: 50%" :label="$t('orders.receiver')">
                <a-select
                  v-model="receiver.id"
                  show-search
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  @inputKeydown="searchUser"
                >
                  <a-select-option @click.native="selectUser(u)" v-for="u in receivers" :key="u.userId">
                    {{ u.userName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item style="width: 50%" :label="$t('orders.ratio')">
                <a-input v-model="receiver.ratio" />
              </a-form-model-item>
            </div>
            <div
              v-for="(h, i) in helpers"
              :key="h.id"
              style="width: 50%; display: flex; justify-content: space-between;"
              class="inline"
            >
              <a-form-model-item style="width: 50%" :label="$t('orders.helper')">
                <a-tooltip>
                  <template slot="title">{{ $t('buttons.delete') }}</template>
                  <a-icon
                    type="minus-square"
                    style="position: absolute; left: -80px; top: 2px; cursor: pointer; font-size: 16px"
                    @click="removeHelper(i)"
                  />
                </a-tooltip>
                <a-select
                  style="width: 110%"
                  show-search
                  v-model="h.userId"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  @inputKeydown="searchHelper"
                >
                  <a-select-option @click.native="selectHelper(r, i)" v-for="r in orderHelpers" :key="r.userId">{{ r.userName }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item style="width: 50%" :label="$t('orders.ratio')">
                <a-input v-model="h.ratio" />
              </a-form-model-item>
            </div>
          </a-form-model>
          <a-button @click="addHelpers" type="primary" icon="plus" style="margin-left: 40px" />
        </a-modal>
      </a-card>
    </div>
  </div>
</template>

<script>
import { searchReceiver, distribute, searchHelper } from '@/api/operator'
import {
  addDevice,
  updateDevice,
  generateDeviceCode,
  searchDeviceList
} from "@/api/device";
import { getDict } from "@/api/dict";
import { searchCustomerList } from "@/api/customer";
import { searchProtocolCode } from "@/api/protocol";
import { getSystemLog } from "@/api/SystemLog";
import { getCustomerById } from "@/api/customer";
import moment from "moment";
import { getOrders, createOrderNo, searchOrderOperators } from '@/api/order'
import OrderModal from '@/components/common/OrderModal'
import TextHighlight from 'vue-text-highlight'
import { nanoid } from 'nanoid'
import { getList, removeS } from '@/api/service'
import ServiceModal from '@/components/common/ServiceModal'
import { getVincinity, refreshPosition } from '@/api/device'
import Monitor from '../View/Monitor.vue'
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import WarningRemind from '../View/WarningRemind.vue'
import WarningHistory from '../View/WarningHistory.vue'

const queryParams = {
  query: [
    {
      field: "company",
      value: ""
    }
  ],
  filter: [],
  sort: []
};

export default {
  name: "index",
  components: { OrderModal, TextHighlight, ServiceModal, Monitor, WarningRemind, WarningHistory },
  async created() {
    locale.use(this[this.lang])
    const a = this.getAuthorities('/equipment/list')
    if (a.find(aa => aa.code === 'device:manage:device:insert' || aa.code === 'device:manage:device:update')) {
      this.isAgent = false
    } else if (a.find(aa => aa.code === 'agent:device:manage:device:insert' || aa.code === 'agent:device:manage:device:update')) {
      this.isAgent = true
    }
    if (this.$store.state.deviceInfo) {
      this.deviceMap = {}
      if (this.$route.query.key) {
        if (this.$route.query.key === "warningHistory") {
          this.onDeviceTabChange("warning", "warningHistory")
        } else {
          this.onDeviceTabChange(this.$route.query.key)
        }
      }
      const auths = this.getAuthorities('/service').concat(this.getAuthorities('/order')).concat(this.getAuthorities('/equipment/list'))
      this.tabList = []
      if (auths.find(a => a.code === 'after:sale:order:query')) {
        this.tabList.push({
          key: "orders",
          tab: this.$t('orders.title')
        })
      }
      if (auths.find(a => a.code === 'after:sale:document:query')) {
        this.tabList.push({
          key: 'service',
          tab: this.$t('saleDocument.title')
        })
      }
      if (auths.find(a => a.code === 'system:log:query:device')) {
        this.tabList.push({
          key: "record",
          tab: this.$t('common.record')
        })
      }
      this.Authorities = auths
      let d = this.$store.state.deviceInfo;
      if (typeof d === "string") {
        const { data } = await searchDeviceList(1, 10, {
          query: [],
          filter: [
            {
              field: "code",
              value: d
            }
          ],
          sort: []
        });
        d = data.records[0];
      }
      this.title = "编辑设备";
      for (let k in this.deviceForm) {
        this.deviceForm[k] = d[k];
      }
      this.selectedDeviceList = d.bindingDevices
      this.deviceForm.status = (this.deviceForm.status || []).join(',')
      this.deviceForm.id = d.id;
      this.params.requestParameters = `"code":"${d.code}"`;
      if (d.customer) {
        this.deviceForm.customerId = d.customerId;
        this.customerResultList.push(d.customer);
      } else {
        this.deviceForm.customerId = undefined;
        this.customerResultList = [];
      }
      this.deviceForm.startTime = this.deviceForm.startTime ? moment(this.deviceForm.startTime) : null
      this.deviceForm.endTime = this.deviceForm.endTime ? moment(this.deviceForm.endTime) : null
      this.orderParams.deviceCode = this.deviceForm.code
      this.SQueryParams.equipmentCode = this.deviceForm.code
      this.setTypeAndStateMap()
      if (this.tabList.length) {
        this.tabKey = this.tabList[0].key
        this.onTabChange(this.tabKey)
      }
    } else {
      this.tabList = [];
    }
    this.translate()
    // protocolApi.listAll().then(({ data }) => {
    //   this.protocolList = data
    // }).then(() => {
    //   return deviceApi.getDeviceType()
    // }).then(({ data }) => {
    //   this.deviceTypeList = data
    // }).catch(() => {
    //   // this.$message.error("请求失败")
    // })
    getDict("zh-CN", "deviceType").then(({ data }) => {
      this.deviceTypeList = data.content.map(c => {
        this.deviceTypeMap[c.value] = c.text;
        return c;
      });
      this.deviceTypes = data.content
      this.deviceTypes.unshift({
        text: '全部',
        value: ''
      })
    });
    getDict("zh-CN", "warningTag").then(({ data }) => {
      this.warningTags = data.content
    });
    getDict("zh-CN", "deviceStatus").then(({ data }) => {
      this.deviceStatusList = data.content;
    });
    getDict("zh-CN", "driverType").then(({ data }) => {
      this.driveTypeList = data.content;
    });
    const { data } = await getDict('zh-CN', 'deviceBusinessType')
    this.businessTypes = data.content.map(c => {
      this.businessTypeMap[c.value] = c.text
      return c
    })
  },
  data() {
    return {
      title: "",
      deviceTypeMap: {},
      driveTypeList: [],
      protocolList: [],
      customerResultList: [],
      deviceTypeList: [],
      deviceStatusList: [],
      customerResultList: [],
      systemLogList: [],
      isSystemLogShow: false,
      isSystemLogLoading: false,
      countDown: null,
      en,
      zh,
      deviceForm: {
        code: "",
        name: "",
        type: "",
        status: null,
        deviceAddress: "",
        model: "",
        brand: "",
        customerId: undefined,
        installAddress: "",
        driverType: "",
        protocolCode: "",
        measurement: "",
        dtuCode: "",
        remark: "",
        isStationDevice: true,
        initialValue: "",
        power: "",
        pressure: "",
        warrantyPeriod: null,
        intervalTime: "",
        enabled: true,
        businessType: null,
        startTime: null,
        endTime: null,
        tag: null
      },
      vincinityLoading: false,
      systemLogPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      params: {
        name: "",
        request: "",
        sort: "DESC",
        requestParameters: "",
        path: "/device/",
        module: "device-manage"
      },
      timer: null,
      isSelectionShow: false,
      rules: {
        code: [
          {
            required: true,
            message: this.$t('messages.pedc'),
            trigger: 'blur'
          },
          {
            pattern: /^[a-zA-Z\d]+$/,
            message: this.$t('messages.lon'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.pedn'),
            trigger: 'blur'
          }
        ],
        model: [
          {
            required: true,
            message: this.$t('messages.pedm'),
            trigger: 'blur'
          }
        ],
        deviceAddress: [
          {
            required: true,
            message: this.$t('messages.peda'),
            trigger: 'blur'
          }
          // {
          //   min: 2,
          //   max: 2,
          //   message: '站号地址必须为2位',
          //   trigger: 'blur'
          // },
          // {
          //   validator(rule, value, callback) {
          //     if (value === '16') {
          //       return callback('请输入正确的16进制地址')
          //     }
          //     const reg = new RegExp(/^[0-9a-f]+$/i)
          //     if(reg.test(value)) {
          //       callback()
          //     } else {
          //       callback(reg.test(value))
          //     }
          //   },
          //   message: '请输入正确的16进制地址',
          //   trigger: 'blur'
          // }
        ],
        type: [
          {
            required: true,
            message: this.$t('messages.pedt')
          }
        ],
        // status: [
        //   {
        //     required: true,
        //     message: '请选择设备状态'
        //   }
        // ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.pec')
          }
        ],
        driverType: [
          {
            required: true,
            message: this.$t('messages.pedd')
          }
        ],
        protocolCode: [
          {
            required: true,
            message: this.$t('messages.pedp'),
            trigger: 'blur'
          }
        ],
        dtuCode: [
          {
            required: true,
            message: this.$t('messages.pedtu')
          }
        ],
        intervalTime: [
          {
            required: true,
            message: this.$t('messages.psi')
          }
        ]
      },
      protocolCode: "",
      protocolShow: false,
      page: 1,
      protocolPage: 1,
      currentModule: "device-manage",
      tabList: [
        {
          key: "orders",
          tab: this.$t('orders.title')
        },
        {
          key: 'service',
          tab: this.$t('saleDocument.title')
        },
        {
          key: "record",
          tab: this.$t('common.record')
        }
      ],
      tabKey: "",
      orders: [],
      ordersColumns: [
        {
          title: () => this.$t('orders.code'),
          dataIndex: "id",
          key: "id"
        },
        {
          title: () => this.$t('commone.createdAt'),
          dataIndex: "createdAt",
          key: "createdAt"
        },
        {
          title: () => this.$t('commone.operation'),
          key: "operation"
        }
      ],
      // orderData
      tableLoading: false,
      orders: [],
      orderParams: {
        orderNo: '',
        orderType: '',
        orderState: '',
        receiver: '',
        cancelState: '0',
        company: '',
        contactPerson: '',
        deviceCode: '',
        deviceName: ''
      },
      stateMap: {},
      typeMap: {},
      orderPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      orderVisible: false,
      orderNo: '',
      deviceId: 0,
      customerId: 0,
      addLoading: false,
      rushVisible: false,
      isRushing: false,
      receiver: {
        id: '',
        ratio: ''
      },
      receivers: [],
      helpers: [],
      orderHelpers: [],
      originHelpersData: [],
      isSLoading: false,
      serviceList: [],
      SQueryParams: {
        orderNum: '',
        serviceType: '',
        equipmentCode: '',
        equipmentName: '',
        equipmentModel: '',
        customer: '',
        servicehours: '',
        serviceContent: '',
        serviceman: '',
        updateman: ''
      },
      sHighLightInfo: {
        orderNum: '',
        serviceType: '',
        equipmentCode: '',
        equipmentName: '',
        equipmentModel: '',
        customer: '',
        servicehours: '',
        serviceContent: '',
        serviceman: '',
        updateman: ''
      },
      sPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      SVisible: false,
      sRecord: undefined,
      sTitle: this.$t('saleDocument.addTitle'),
      Authorities: [],
      deviceTabList: [
        {
          key: 'details',
          tab: this.$t('device.details')
        },
        {
          key: 'monitor',
          tab: this.$t('device.monitor')
        },
        {
          key: 'map',
          tab: this.$t('device.map')
        },
        {
          key: "warning",
          tab: this.$t('device.warningRemind')
        }
      ],
      deviceTabKey: 'details',
      selectedDeviceList: [],
      isDeviceTableVisible: false,
      deviceTableLoading: false,
      columns: [
        {
          title: () => (
            <div>
              { this.$t('common.deviceCode') }
              <a-input v-model={ this.queryParams.code } onKeyup={ (e) => e.key === 'Enter' && this.handleSearch() } />
            </div>
          ),
          dataIndex: 'code',
          key: 'code',
          scopedSlots: {
            customRender: "code"
          }
        },
        {
          title: () => (
            <div>
              { this.$t('common.deviceName') }
              <a-input v-model={ this.queryParams.name } onKeyup={ (e) => e.key === 'Enter' && this.handleSearch() } />
            </div>
          ),
          width: 100,
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {
            customRender: "name"
          }
        },
        {
          title: () => (
            <div>
              { this.$t('common.model') }
              <a-input v-model={ this.queryParams.model } onKeyup={ (e) => e.key === 'Enter' && this.handleSearch() } />
            </div>
          ),
          width: 100,
          dataIndex: 'model',
          key: 'model',
          scopedSlots: {
            customRender: "model"
          }
        },
        {
          title: () => (
            <div>
              { this.$t('common.customerName') }
              <a-input v-model={ this.queryParams['customer.company'] } onKeyup={ (e) => e.key === 'Enter' && this.handleSearch() } />
            </div>
          ),
          width: 200,
          dataIndex: 'customer.company',
          key: 'customer.company',
          scopedSlots: {
            customRender: "company"
          }
        },
        {
          title: () => (
            <div>
              { this.$t('common.deviceType') }
              <a-select style="width: 110px" v-model={ this.queryParams.type } onChange={ this.handleSearch }>
                {
                  this.deviceTypes.map(t => (
                    <a-select-option value={ t.value }>
                      { t.text }
                    </a-select-option>
                  ))
                }
              </a-select>
            </div>
          ),
          dataIndex: 'type',
          key: 'type',
          scopedSlots: {
            customRender: "type"
          }
        },
        {
          title: () => (
            <div>
              { this.$t('common.protocolCode') }
              <a-input v-model={ this.queryParams.protocolCode } onKeyup={ (e) => e.key === 'Enter' && this.handleSearch() } />
            </div>
          ),
          dataIndex: 'protocolCode',
          key: 'protocolCode',
          scopedSlots: {
            customRender: "protocolCode"
          }
        },
        {
          title: () => (
            <div>
              { this.$t('common.dtuCode') }
              <a-input v-model={ this.queryParams.dtuCode } onKeyup={ (e) => e.key === 'Enter' && this.handleSearch() } />
            </div>
          ),
          dataIndex: 'dtuCode',
          key: 'dtuCode',
          scopedSlots: {
            customRender: "dtuCode"
          }
        },
        {
          title: () => (
            <div>
              { this.$t('common.driverType') }
              <a-input v-model={ this.queryParams.driverType } onKeyup={ (e) => e.key === 'Enter' && this.handleSearch() } />
            </div>
          ),
          dataIndex: 'driverType',
          key: 'driverType',
          scopedSlots: {
            customRender: "driverType"
          }
        }
      ],
      queryParams: {
        code: '',
        name: '',
        'customer.company': '',
        type: '',
        model: '',
        protocolCode: '',
        dtuCode: '',
        driverType: ''
      },
      highLightInfo: {
        code: '',
        name: '',
        'customer.company': '',
        type: '',
        model: '',
        protocolCode: '',
        dtuCode: '',
        driverType: '',
        orderNo: '',
        receiver: '',
        company: '',
        contactPerson: '',
        deviceCode: '',
        deviceName: ''
      },
      rowSelection: {
        selectedRowKeys: [],
        onChange: this.handleRowChange
      },
      deviceList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      businessTypes: [],
      businessTypeMap: {},
      isAgent: false,
      warningTags: [],
      currentWarningMode: []
    };
  },
  computed: {
    paramList() {
      return this.protocolList.filter(
        item =>
          item.protocolCode.includes(this.protocolCode) ||
          item.protocolName.includes(this.protocolCode)
      );
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang(v) {
      locale.use(this[v])
      this.translate()
    }
  },
  async mounted() {
    try {
      await this.loadScript("https://webapi.amap.com/maps?v=2.0&key=72d96f391e31901608daed111c3535e4")
      await this.loadScript("//webapi.amap.com/ui/1.1/main.js")
      this.scriptLoadedSuccess = true
      this.initMapChart()
    } catch(e) {
      console.log(e)
      this.scriptLoadedSuccess = false
    }
    // setTimeout(() => {
    //   if (this.vincinityLoading) {
    //     this.initMapChart([])
    //   }
    // }, 300)
    // this.getVincinity()
  },
  // beforeDestroy() {
  //   this.$store.commit("setDeviceInfo", null);
  // },
  methods: {
    async loadScript(src) {
      return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${src}"]`)
        if (existingScript) {
          resolve()
          return
        }
        const script = document.createElement("script")
        script.type = "text/javascript"
        script.src = src
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },
    translate() {
      this.deviceTabList = [
        {
          key: 'details',
          tab: this.$t('device.details')
        },
        {
          key: 'monitor',
          tab: this.$t('device.monitor')
        },
        {
          key: 'map',
          tab: this.$t('device.map')
        },
        {
          key: "warning",
          tab: this.$t('device.warningRemind')
        }
      ]
      this.rules = {
        code: [
          {
            required: true,
            message: this.$t('messages.pedc'),
            trigger: 'blur'
          },
          {
            pattern: /^[a-zA-Z\d]+$/,
            message: this.$t('messages.lon'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.pedn'),
            trigger: 'blur'
          }
        ],
        model: [
          {
            required: true,
            message: this.$t('messages.pedm'),
            trigger: 'blur'
          }
        ],
        deviceAddress: [
          {
            required: true,
            message: this.$t('messages.peda'),
            trigger: 'blur'
          }
          // {
          //   min: 2,
          //   max: 2,
          //   message: '站号地址必须为2位',
          //   trigger: 'blur'
          // },
          // {
          //   validator(rule, value, callback) {
          //     if (value === '16') {
          //       return callback('请输入正确的16进制地址')
          //     }
          //     const reg = new RegExp(/^[0-9a-f]+$/i)
          //     if(reg.test(value)) {
          //       callback()
          //     } else {
          //       callback(reg.test(value))
          //     }
          //   },
          //   message: '请输入正确的16进制地址',
          //   trigger: 'blur'
          // }
        ],
        type: [
          {
            required: true,
            message: this.$t('messages.pedt')
          }
        ],
        // status: [
        //   {
        //     required: true,
        //     message: '请选择设备状态'
        //   }
        // ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.pec')
          }
        ],
        driverType: [
          {
            required: true,
            message: this.$t('messages.pedd')
          }
        ],
        protocolCode: [
          {
            required: true,
            message: this.$t('messages.pedp'),
            trigger: 'blur'
          }
        ],
        dtuCode: [
          {
            required: true,
            message: this.$t('messages.pedtu')
          }
        ],
        intervalTime: [
          {
            required: true,
            message: this.$t('messages.psi')
          }
        ]
      }
      this.sTitle = this.$t('saleDocument.' + (this.lKey || 'addTitle'))
    },
    async getVincinity() {
      let e = []
      let c
      this.vincinityLoading = true
      try {
        const { data } = await getVincinity(this.deviceForm.code)
        if (data.length) {
          const i = data.at(-1)
          e = [[i.lng, i.lat, "", i.company]]
          c = [i.lng, i.lat]  
        } else {
          const { data } = await refreshPosition(this.deviceForm.code)
          if (data.id) {
            const i = data
            if (i.lng && i.lat) {
              e = [[i.lng, i.lat, "", i.company]]
              c = [i.lng, i.lat]
            }
          }
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.vincinityLoading = false
        if (!e.length) {
          this.initMapChart(e, c, 5)
          return this.$message.info(this.$t('device.np'))
        } else {
          this.initMapChart(e, c, 12)
        }
      }
    },
    initMapChart(e, c, z) {
      const option = this.getMapOption(e, c, z);
      // this.$refs.mapChart.style.scale = this.rate
      if (!this.mapChart) {
        this.mapChart = this.$echarts.init(this.$refs.mapChart);
      }
      this.mapChart.setOption(option);
    },
    getMapOption(data, center = [120.5, 29.4], zoom = 5) {
      return {
        amap: {
          center: center,
          zoom: zoom,
          resizeEnable: true,
          renderOnMoving: true,
          // mapStyle: "amap://styles/darkblue",
          zooms: [4, 25]
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.8)',
          borderWidth: 0,
          textStyle: {
            color: '#fff'
          },
          formatter: function (params) {
            return params.data[3]
          }
        },
        animation: true,
        series: [
          {
            type: "effectScatter",
            coordinateSystem: "amap",
            data: data,
            symbol: 'image://data:image/png;base64,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',
            symbolSize: 20,
            encode: {
              value: 2
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            hoverAnimation: true,
            // label: {
            //   normal: {
            //     formatter: "{@[2]}",
            //     position: "inside",
            //     show: true,
            //     fontSize: 12 * this.rate
            //   }
            // },
            zlevel: 1
          }
        ]
      };
    },
    async setTypeMap() {
      try {
        let map = {}
        const type = await getDict('zh-CN', 'afterSaleServerItem')
        type.data.content.forEach(c => {
          map[c.value] = c.text
        })
        this.typeMap = map
      } catch(e) {
        console.log(e)
      }
    },
    changeStartTime(date, dateString) {
      if (date) {
        this.params.startTime = +new Date(dateString);
      } else {
        delete this.params.startTime;
      }
    },
    changeEndTime(date, dateString) {
      console.log(date, dateString);
      if (date) {
        this.params.endTime = +new Date(dateString) + 24 * 3600 * 1000 - 1;
      } else {
        delete this.params.endTime;
      }
    },
    selectCustomer(value) {
      this.deviceForm.customerId = value.id;
      this.deviceForm.companyName = value.companyName;
      this.selected = true;
    },
    selectProtocol(value) {
      const res = this.protocolList.find(item => item.protocolCode === value);
      console.log(res);
      this.deviceForm.driverType = res.driverType;
      this.deviceForm.intervalTime = res.intervalTime + "";
    },
    async getDescription(row) {
      const d = JSON.parse(row.requestParameters)?.device || {};
      try {
        const { data } = await getCustomerById(d.customerId);
        this.customerResultList.push(data);
        d.company = data.company;
        if (d.enabled === undefined || d.enabled === null) {
          d.enabled = "";
        } else {
          d.enabled = d.enabled ? this.$t('device.no') : this.$t('device.yes');
        }
        return d
      } catch (e) {
        return this.$t('common.nd')
      }
    },
    compareTwoRows(showRow, comparationRow) {
      for (let k in showRow) {
        if (k === 'startTime' || k === 'endTime') {
          showRow[k] = showRow[k] ? moment(showRow[k]).format('YYYY-MM-DD') : ''
          comparationRow[k] = comparationRow[k] ? moment(comparationRow[k]).format('YYYY-MM-DD') : ''
        }
        if (showRow[k] !== comparationRow[k]) {
          showRow[k] = [this.changeEmptyToChinese(comparationRow[k]), this.changeEmptyToChinese(showRow[k])]
        }
        if (!Array.isArray(showRow[k])) {
          showRow[k] = this.changeEmptyToChinese(showRow[k])
        }
      }
    },
    changeEmptyToChinese(t) {
      if (t === "EMPTY") {
        return "空"
      } else {
        return t
      }
    },
    async handleExpand(row) {
      row.expanded = !row.expanded;
      if (row.expanded && !row.description) {
        if (this.params.module === "device-manage") {
          try {
            const d = await this.getDescription(row)
            let row1
            const index = this.systemLogList.findIndex(s => s.id === row.id)
            if (index < this.systemLogList.length - 1) {
              row1 = this.systemLogList[index + 1]
              const description = await this.getDescription(row1)
              this.compareTwoRows(d, description)
              row.description = d
            } else {
              if (this.systemLogPagination.current * this.systemLogPagination.pageSize < this.systemLogPagination.total) {
                if (row.request !== 'POST') {
                  const { data } = await getSystemLog({
                    current: this.systemLogPagination.current + 1,
                    pageSize: this.systemLogPagination.pageSize,
                    ...this.params
                  })
                  row1 = data.records[0]
                  const description = await this.getDescription(row1)
                  this.compareTwoRows(d, description)
                  row.description = d
                } else {
                  row.description = d
                  d.startTime = d.startTime ? moment(+d.startTime).format('YYYY-MM-DD') : null
                  d.endTime = d.endTime ? moment(+d.endTime).format('YYYY-MM-DD') : null
                }
              } else {
                row.description = d
                d.startTime = d.startTime ? moment(+d.startTime).format('YYYY-MM-DD') : null
                d.endTime = d.endTime ? moment(+d.endTime).format('YYYY-MM-DD') : null
              }
            }
          } catch(e) {
            console.log(e)
            row.description = {}
          }
        }
        if (this.params.module === "device-connect") {
          const d = JSON.parse(row.requestParameters) || {};
          row.description = d;
        }
      }
    },
    async handleTypeChange(value) {
      if (value === "LGJ") {
        this.deviceForm.code = "";
        return;
      }
      try {
        const { data } = await generateDeviceCode({ deviceType: value });
        this.deviceForm.code = data;
      } catch (e) {
        console.log(e);
      }
    },
    handleModuleChange(value) {
      if (value === "device-manage") {
        this.params.request = this.requestRecord || "";
        this.pathRecord = this.params.path;
        this.params.path = "/device/";
        this.params.requestParameters = `"code":"${this.$store.state.deviceInfo.code}"`;
      }
      if (value === "device-connect") {
        this.params.path = this.pathRecord || "";
        this.requestRecord = this.params.request;
        this.params.request = "";
        this.params.requestParameters = `"deviceCode":"${this.$store.state.deviceInfo.code}"`;
      }
    },
    goBack() {
      this.$store.commit("setDeviceFlag", true);
      this.$store.commit('setDeviceInfo', null)
      this.$router.back();
    },
    save() {
      // this.deviceForm.initialValue = +this.deviceForm.initialValue
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const deviceForm = { ...this.deviceForm }
          deviceForm.bindingDevices = (this.selectedDeviceList || []).map(s => ({ id: s.id }))
          deviceForm.startTime = this.deviceForm.startTime ? this.deviceForm.startTime._d.getTime() : null
          deviceForm.endTime = this.deviceForm.endTime ? this.deviceForm.endTime._d.getTime() : null
          deviceForm.tag = deviceForm.tag || null
          deviceForm.deviceAddress = deviceForm.deviceAddress.length < 2 ? "0" + deviceForm.deviceAddress : deviceForm.deviceAddress
          if (this.$store.state.deviceInfo) {
            updateDevice(deviceForm)
              .then(({ message }) => {
                this.$message.success(message);
              })
              .catch(({ message }) => {
                this.$message.warn(message);
              });
          } else {
            addDevice(deviceForm)
              .then(({ message }) => {
                this.$message.success(message);
              })
              .catch(({ message }) => {
                this.$message.warn(message);
              });
          }
        }
      });
    },
    handleSystemPageChange(page) {
      this.systemLogPagination.current = page;
      this.getS();
    },
    /*  */
    debounce(f, delay, ...args) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        f(...args);
        this.timer = null;
      }, delay);
    },
    async handlePopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.page++;
        const { data } = await searchCustomerList(this.page, 10, queryParams);
        this.customerResultList = this.customerResultList.concat(data.records);
      }
    },
    async handleProtocolPopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.protocolPage++;
        const { data } = await searchProtocolCode(
          this.protocolPage,
          10,
          this.value,
          this.value
        );
        this.protocolList = this.protocolList.concat(data.records);
      }
    },
    handleSearchCustomer(value) {
      this.debounce(async () => {
        try {
          queryParams.query[0].value = value;
          const { data } = await searchCustomerList(this.page, 10, queryParams);
          this.customerResultList = data.records;
          this.page = 1;
        } catch (e) {
          console.log(e);
        }
      }, 300);
    },
    handleSearchProtocol(value) {
      this.value = value;
      this.debounce(async () => {
        try {
          const { data } = await searchProtocolCode(
            this.protocolPage,
            10,
            this.value,
            this.value
          );
          this.protocolList = data.records;
          this.protocolPage = 1;
        } catch (e) {
          console.log(e);
        }
      }, 300);
    },
    async handleProtocolPopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.protocolPage++;
        const { data } = await searchProtocolCode(
          this.protocolPage,
          10,
          this.value,
          this.value
        );
        this.protocolList = this.protocolList.concat(data.records);
      }
    },
    async getS() {
      this.isSystemLogLoading = true;
      console.log(this.systemLogPagination)
      try {
        const { data } = await getSystemLog({
          current: this.systemLogPagination.current,
          pageSize: this.systemLogPagination.pageSize,
          ...this.params
        });
        this.systemLogPagination.current = data.current;
        this.systemLogPagination.pageSize = data.size;
        this.systemLogPagination.total = data.total;
        this.systemLogList = data.records.map(r => {
          r.description = false;
          r.time = moment(r.time).format("YYYY-MM-DD HH:mm:ss");
          if (this.params.module === "device-manage") {
            if (r.request === "POST") {
              r.request = this.$t('buttons.add');
            }
            if (r.request === "PUT") {
              r.request = this.$t('common.update');
            }
          }
          if (this.params.module === "device-connect") {
            if (r.path === "/device/write/value") {
              r.request = this.$t('device.writeValue');
            }
            if (r.path === "/device/switch") {
              r.request = this.$t('device.switchDevice');
            }
          }
          return r;
        });
        this.currentModule = this.params.module;
      } catch (e) {
        console.log(e);
      } finally {
        this.isSystemLogLoading = false;
      }
    },
    showSystemLog() {
      // this.isSystemLogShow = true;
      this.getS();
    },
    handleBlur() {
      this.page = 1;
      this.protocolPage = 1;
      this.protocolList = [];
      this.userList = [];
      this.$forceUpdate();
    },
    handleChange(value) {
      const p = this.protocolList.find(p => p.code === value);
      this.deviceForm.driverType = p.driver;
      this.deviceForm.intervalTime = p.intervalTime;
    },
    search(e) {
      if (e.target.value.trim() === "") {
        this.isSelectionShow = false;
      } else {
        this.debounce(this.searchCustomer, 500, e.target.value);
      }
    },
    handleFocus(e) {
      this.selected = false;
      if (e.target.value.trim() === "") {
        this.customerResultList = [];
      } else {
        this.isSelectionShow = true;
      }
    },
    handleBlur() {
      this.page = 1;
      this.protocolPage = 1;
      this.protocolList = [];
      this.userList = [];
      this.$forceUpdate();
    },
    selecteProtocol(item) {
      this.protocolCode = this.deviceForm.protocolCode = item.protocolCode;
      this.deviceForm.driverType = item.driverType;
    },
    async onTabChange(key) {
      this.tabKey = key;
      if (key === "record") {
        this.showSystemLog();
      }
      if (key === 'orders') {
        this.getOrdersList()
      }
      if (key === 'service') {
        this.getData()
      }
    },
    onDeviceTabChange(key, currentWarningMode) {
      this.deviceTabKey = key
      if (this.mapChart) {
        this.mapChart.dispose()
        this.mapChart = null
      }
      if (key === 'map') {
        setTimeout(() => {
          if (this.vincinityLoading) {
            this.initMapChart([])
          }
        }, 300)
        this.getVincinity()
      }
      if (key === "warning") {
        if (currentWarningMode) {
          this.currentWarningMode = [currentWarningMode]
        } else {
          this.currentWarningMode = ["warningRemind"]
        }
      }
    },
    // orderMethods
    async getOrdersList() {
      this.tableLoading = true
      try {
        const { data } = await getOrders(this.orderPagination.current, this.orderPagination.pageSize, this.orderParams)
        this.orders = data.records
        for (let k in this.highLightInfo) {
          this.highLightInfo[k] = this.orderParams[k] || ''
        }
        this.orderPagination.current = data.current
        this.orderPagination.total = data.total
      } catch(e) {
        console.log(e)
      } finally {
        this.tableLoading = false
      }
    },
    gotoEdit(row) {
      this.$router.push({
        path: '/order/detail',
        query: {
          orderNo: row.orderNo,
          orderType: row.orderType,
          note: row.note,
          orderScore: row.orderScore,
          customerId: row.customerId,
          deviceId: row.deviceId,
          preemptOrderId: row.preemptOrderId,
          orderState: row.orderState
        }
      })
    },
    async setTypeAndStateMap() {
      try {
        let map = {}
        const type = await getDict('zh-CN', 'afterSaleServerItem')
        type.data.content.forEach(c => {
          map[c.value] = c.text
        })
        this.typeMap = map
        map = {}
        const state = await getDict('zh-CN', 'afterSaleOrderStatus')
        state.data.content.forEach(c => {
          map[c.value] = c.text
        })
        this.stateMap = map
      } catch(e) {
        console.log(e)
      }
    },
    handleOrderPageChange(p) {
      this.orderPagination.current = p
      this.getOrdersList()
    },
    closeModal() {
      this.orderVisible = false
      this.orderNo = ''
      this.getOrdersList()
    },
    async showOrderModal() {
      this.isAddingOrder = true
      try {
        this.deviceId = this.deviceForm.id
        this.customerId = this.deviceForm.customerId
        const { data } = await createOrderNo()
        this.orderNo = data
      } catch(e) {
        console.log(e)
      } finally {
        this.addLoading = false
        this.orderVisible = true
      }
    },
    async rush() {
      this.isRushing = true
      try {
        const os = []
        os.push({
          orderId: this.orderId,
          userId: this.receiver.id,
          orderRole: 1,
          orderRate: this.receiver.ratio
        })
        for (let i = 0; i < this.helpers.length; i++) {
          const h = this.helpers[i]
          os.push({
            orderId: this.orderId,
            userId: h.userId,
            orderRole: 2,
            orderRate: h.ratio
          })
        }
        const { message } = await distribute(os)
        this.$message.success(message);
        this.rushVisible = false
        this.clearRushForm()
        this.getOrdersList()
      } catch(e) {
        console.log(e)
      } finally {
        this.isRushing = false
      }
    },
    clearRushForm() {
      this.receiver = {
        id: '',
        orderRate: ''
      },
      this.helpers = []
      this.orderHelpers = []
    },
    searchUser(e) {
      if (e.code === 'Enter') {
        e.target.value = e.target.value.trim()
        this.getOperators(e.target.value)
      }
    },
    async getOperators(userName = '') {
      try {
        const { data } = await searchReceiver({
          userName
        });
        this.receivers = data;
      } catch (e) {
        console.log(e);
      }
    },
    removeHelper(i) {
      this.helpers.splice(i, 1)
    },
    selectHelper(r, i) {
      this.helpers[i] = {
        id: this.helpers[i].id,
        ...r
      }
    },
    addHelpers() {
      this.helpers.push({
        id: nanoid()
      })
    },
    async showRushModal(row) {
      row.readyToRush = true
      try {
        await this.getHelpers()
        await this.getOperators()
        const { data } = await searchOrderOperators({
          preemptOrderId: row.preemptOrderId
        })
        data.forEach(d => {
          if (d.orderRole === 1) {
            this.receiver.id = d.userId;
            this.receiver.ratio = d.orderRate
          }
          if (d.orderRole === 2) {
            this.helpers.push({
              ...d,
              id: nanoid(),
              ratio: d.orderRate
            })
          }
        })
        this.orderId = row.preemptOrderId
        this.rushVisible = true
      } catch(e) {
        console.log(e)
      } finally {
        row.readyToRush = false
      }
    },
    selectUser(u) {
      if (u.userId === this.receiver.id) return
      this.receiver.ratio = u.ratio
      this.helpers = u.assistant.map(a => {
        return {
          ...a,
          id: nanoid()
        }
      })
    },
    async getHelpers(userName = '') {
      try {
        const { data } = await searchHelper({
          userName
        })
        this.orderHelpers = data
      } catch(e) {
        console.log(e)
      }
    },
    searchHelper(e) {
      if (e.code === "Enter") {
        e.target.value = e.target.value.trim();
        this.getHelpers(e.target.value)
      }
    },
    handleTableChange(current) {
      this.sPagination.current = current
      this.getData()
    },
    async getData(rp) {
      this.isSLoading = true
      if (rp) {
        this.sPagination.current = 1
      }
      try {
        const { data } = await getList(this.sPagination.current, this.sPagination.pageSize, this.SQueryParams)
        this.serviceList = data.records
        this.sPagination.total = data.total
        this.$forceUpdate()
        for (let k in this.sHighLightInfo) {
          this.sHighLightInfo[k] = this.SQueryParams[k]
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isSLoading = false
      }
    },
    onEdit(r) {
      this.lKey = 'editTitle'
      this.sTitle = this.$t('saleDocument.editTitle')
      this.SVisible = true
      this.sRecord = r
    },
    closeSModal(f) {
      this.SVisible = false
      this.sRecord = undefined
      if (f) {
        this.getData()
      }
    },
    async removeService(row) {
      row.loading = true
      this.serviceList = [...this.serviceList]
      try {
        const { message } = await removeS(row.id)
        this.$message.success(message)
        this.getData()
      } catch(e) {
        console.log(e)
      } finally {
        row.loading = false
        this.serviceList = [...this.serviceList]
      }
    },
    showServiceModal() {
      this.sRecord = {
        equipmentId: this.deviceForm.id,
        equipmentCode: this.deviceForm.code,
        equipmentName: this.deviceForm.name,
        equipmentModel: this.deviceForm.model,
        customerId: this.deviceForm.customerId,
        customer: this.$store.state.deviceInfo.customer.company,
        protocolCode: this.deviceForm.protocolCode
      }
      this.SVisible = true
      this.sTitle = this.$t('saleDocument.addTitle')
      this.lKey = 'addTitle'
    },
    showDeviceTableModal() {
      this.isDeviceTableVisible = true
      if (!this.deviceList?.length) {
        this.getDeviceList()
      }
      this.rowSelection.selectedRowKeys = this.selectedDeviceList.map(s => s.id)
    },
    async getDeviceList() {
      try {
        this.deviceTableLoading = true
        const queryParams = {
          query: [],
          sort: [
            {
              field: 'updatedAt',
              value: 'DESC'
            }
          ],
          filter: []
        }
        for (let key in this.queryParams) {
          queryParams.query.push({
            field: key,
            value: this.queryParams[key]
          })
        }
        const { data } = await searchDeviceList(this.pagination.current, this.pagination.pageSize, queryParams)
        this.deviceList = data.records
        this.pagination.current = data.current
        this.pagination.total = data.total
        for (let key in this.queryParams) {
          this.highLightInfo[key] = this.queryParams[key]
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.deviceTableLoading = false
      }
    },
    handlePageChange(page) {
      this.pagination = page
      this.getDeviceList()
    },
    handleSearch() {
      this.pagination.current = 1
      this.getDeviceList()
    },
    handleRowChange(selectedRowKeys, selectedRows) {
      selectedRows.forEach(s => {
        this.deviceMap[s.id] = s
      })
      this.rowSelection.selectedRowKeys = selectedRowKeys
    },
    handleConfirm() {
      this.selectedDeviceList = this.rowSelection.selectedRowKeys.map(i => this.deviceMap[i])
      this.isDeviceTableVisible = false
    },
    handleRemoveSelectedDevice(i) {
      this.selectedDeviceList.splice(i, 1)
      this.rowSelection.selectedRowKeys = this.selectedDeviceList.map(s => s.id)
    },
    async refreshPosition() {
      let e = []
      let c
      this.vincinityLoading = true
      try {
        const { data } = await refreshPosition(this.deviceForm.code)
        if (data.id) {
          const i = data
          if (i.lng && i.lat) {
            e = [[i.lng, i.lat, "", i.company]]
            c = [i.lng, i.lat]
          }
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.vincinityLoading = false
        if (!e.length) {
          this.initMapChart(e, c, 5)
          return this.$message.info(this.$t('device.np'))
        } else {
          this.initMapChart(e, c, 12)
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
li {
  list-style: none;
}
ul {
  padding: 0;
  margin: 0;
}
.row {
  margin-top: 5px;
}
.selection {
  width: 570px;
  max-height: 260px;
  position: absolute;
  top: 293px;
  left: 570px;
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 5px 0 0 5px;
  /* overflow-y: auto; */
  background-color: #fff;
  z-index: 10;
}
.selection h4 {
  font-size: 16px;
  color: #999;
  line-height: 1;
  padding: 10px 10px 0;
}
.selection li {
  cursor: pointer;
  padding: 8px 10px;
}
li.companyName:hover {
  background-color: #eee;
}
// /deep/ .nLabel .ant-form-item:last-child .ant-form-item-label {
//   opacity: 0;
// }
.orders {
  height: 50%;
  background-color: #f5f4f7;
  padding: 10px;
}
/deep/ .ant-select-selection-selected-value {
  font-weight: normal !important;
}
#map {
  width: 100%;
  height: 100%;
  // background-color: skyblue;
  position: relative;
}
.deviceDetail /deep/.ant-card-body {
  height: 100%;
  padding: 0;
}
.icon {
  width: 30px;
  height: 30px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
/deep/ .ant-form-item {
  margin-bottom: 20px;
}
</style>
